module.exports = __webpack_public_path__ + "img/cj_1.b4fa3655.png";